/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum models_QualificationLevel {
    QualificationQualified = 'QUALIFIED',
    QualificationRecognitionPending = 'RECOGNITION_PENDING',
    QualificationNotQualified = 'NOT_QUALIFIED',
}
